module.exports = __webpack_public_path__ + "static/media/icon-list.f1724e7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-list.svg
// module id = ./src/assets/images/icon-list.svg
// module chunks = 6